export enum METHOD {
  POST = "POST",
  GET = "GET",
}

export const API_STATUS = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  FORBIDDEN: "FORBIDDEN",
};

export const API_STATUS_CODE = {
  SUCCESS: 200,
  ERROR: 500,
  FORBIDDEN: 401,
};
